import { format } from "date-fns";
import { es } from "date-fns/locale";

export const formatDate = (dateStr, formato = "dd/MM/yyyy") => {
  if(dateStr !== undefined || dateStr != null){
    const date = new Date(dateStr);
    return format(date, formato, { locale: es });
  }else{
    // istanbul ignore next
    return "-";
  }
};

export const formatCurrencyEuro = (value) => {
  const numericValue = parseFloat(value);
  if (!isNaN(numericValue)) {
    const formattedAmount = numericValue.toLocaleString('es-ES', { style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return `${formattedAmount} €`;
  }
  // istanbul ignore next
  return value;
};

// istanbul ignore next
export const getSymbolCurrency = (currencyName) =>  {
  const mapeoDivisas = {
      'EUR': ' €',
      'USD': ' $'
    };

    return mapeoDivisas[currencyName] || '';
}

// istanbul ignore next
export const formatPatrimonio = (value, divisa) => {
  if (!value) return '-';
  if(value >= 100000){
      return formatDecimal(value / 1000000) + " M" + getSymbolCurrency(divisa);
  }else if(value >= 1000 && value < 100000){
      return formatDecimal(value/ 1000) + " k" + getSymbolCurrency(divisa);
  }else{
      return formatDecimal(value) + getSymbolCurrency(divisa);
  }
};

export const formatDecimal = (value, fixed = 2) => {
  const numericValue = parseFloat(value);
  if (!isNaN(numericValue)) {
    const formattedAmount = numericValue.toLocaleString('es-ES', { style: 'decimal', minimumFractionDigits: fixed, maximumFractionDigits: fixed });
    return `${formattedAmount}`;
  }
  // istanbul ignore next
  return value;
}

export const formatMillions = (value, fixed = 2) => {
  const numericValue = parseFloat(value);

  if (!isNaN(numericValue)) {
    let formattedAmount;

    if (numericValue >= 1e6) {
      // Si el valor es mayor o igual a un millón, formatearlo en millones
      const millionsValue = numericValue / 1e6;
      formattedAmount = millionsValue.toLocaleString('es-ES', { style: 'decimal', minimumFractionDigits: fixed, maximumFractionDigits: fixed }) + ' M';
    } else if (numericValue >= 1e3) {
      // Si el valor está entre 1000 y menor a 100000, formatearlo en "k €"
      const thousandsValue = numericValue / 1e3;
      formattedAmount = thousandsValue.toLocaleString('es-ES', { style: 'decimal', minimumFractionDigits: fixed, maximumFractionDigits: fixed }) + ' k';
    } else {
      // Si el valor es menor que 1000, formatearlo solo en "€"
      formattedAmount = numericValue.toLocaleString('es-ES', { style: 'decimal', minimumFractionDigits: fixed, maximumFractionDigits: fixed });
    }

    return formattedAmount;
  }

  return value;
}